"use strict";

window.addEventListener("DOMContentLoaded", init);

function init() {
  collectionSlider();
}

function collectionSlider() {
  let swiperCollection = new Swiper(".swiper.collection-slider", {
    speed: 1000,
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
  });
}
